import { useDispatch, useSelector } from "react-redux";
import numberFormat from "lib/numberFormat";
import { AUTH_SUCCESS, handleErrors } from "store/auth";
import { axiosInstance } from "../auth";
import { saveAs } from "file-saver";
import { getValueByPath, resolveListLabel } from "./listLabel";
export { getValueByPath, resolveListLabel };
export const UPDATE_FILED = "coreUpdateField";
export const CLEAR = "coreClear";
export const updateField = ({ prop, value }) => ({
  type: UPDATE_FILED,
  payload: { prop, value },
});

export const useCore = () => {
  const core = useSelector((state) => state.core);
  const dispatch = useDispatch();
  return {
    ...core,
    list,
    clear,
    fetchList,
    getProductCategories,
    getCategories,
    getAdmins,
    getTags,
    getGenres,
    getUsers,
    getRoles,
    getAbilities,
    getActivityFields,
    getPermissions,
    getCountries,
    getSeries,
    getSeasons,
    getCasts,
    dispatch,
    getProductOwners,
    getSliders,
    getMenus,
    getProducts,
    getLanguages,
    getPackages,
    getFestivals,
    getGlobalSearch,
    getCrmSearch,
    getProductViewCount,
    getCrm,
    chargeWallet,
    withdrawWallet,
    editSubscription,
    addSubscription,
    getDirectorDashboard,
    getCrmUserViews,
    getDirectorReportSingle,
    getDirectorReportMovies,
    getDirectorReportScreening,
    getCafes,
    useCafeTicket,
    getFestival,
    manageFestivalWidgets,
    getDirectorYearlyReport,
    getParentMenuItems,
    downloadFestivalReport,
    deleteLiveStream,
    createLiveStream,
    printInvoice,
    storeDirectorProfile,
  };
};

export const printInvoice = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.get(`/orders/${id}/invoice`, {
      responseType: "blob",
    });

    cb(URL.createObjectURL(result.data));
  } catch (e) {
    console.log(e);
    handleErrors(e);
  }
};

function list(value) {
  return value.map((item) => {
    let data = {
      value: item.id,
    };

    let label = item.name || item.title || item.fa_name || item.full_name || "";
    // if user or agent => add last name & mobile
    if (item.first_name) {
      label = item.first_name;
      if (item.last_name) {
        label += " " + item.last_name;
      }
    }
    // if service & product add price
    if (item.price) {
      label += " (" + numberFormat.toOn(item.price) + " ریال)";
    }

    // add price for servie & product
    if (item.price) {
      data.price = item.price;
    }

    // add display name for role
    if (item.display_name) {
      label = item.display_name;
    }
    data.label = label;
    return data;
  });
}

const lookupRequests = new Map();

function newList(value, labelField) {

  return value.map((item) => {
    let data = {
      value: item.id,
    };

    let label = resolveListLabel(item, labelField);

    data.label = label;
    return data;
  });
}

function newList2(value, labelField, labelField2) {
  return value.map((item) => {
    let data = {
      value: item.id,
    };

    let label = resolveListLabel(item, [labelField, labelField2]);

    data.label = label;
    return data;
  });
}

export const clear = () => ({
  type: CLEAR,
});

async function fetchList(
  dispatch,
  filters,
  rel,
  key,
  route,
  disableList = false
) {
  try {
    dispatch(updateField({ prop: `${key}Load`, value: true }));
    let url = `/core/${route}?pagination=false&rel=${rel || ""}`;
    // handle filters

    if (filters) {
      Object.keys(filters).map((item, index) => {
        if (item.length <= 0) {
          return;
        }

        if (filters[item].length > 0 && Array.isArray(filters[item])) {
          filters[item].map((i, index) => {
            url += `&${item}[${index}]=${i}`;
          });
        } else if (!!filters[item]) {
          url += `&${item}=${filters[item]}`;
        }
      });
    }
    const result = await axiosInstance.get(url);
    dispatch(
      updateField({
        prop: key,
        value: disableList ? result.data : list(result.data),
      })
    );
    dispatch(updateField({ prop: `${key}Load`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `${key}Load`, value: false }));

    handleErrors(e);
  }
}

async function fetchListNew(
  dispatch,
  filters,
  key,
  route,
  labelField,
  disableList = false
) {
  try {
    dispatch(updateField({ prop: `${key}Load`, value: true }));

    const params =
      typeof filters === "string"
        ? new URLSearchParams(filters.replace(/\?/, "").replace(/&&/g, "&"))
        : new URLSearchParams(filters || {});

    if (!params.has("page")) {
      params.set("page", "1");
    }

    if (!params.has("perpage")) {
      params.set("perpage", "10000");
    }

    const url = `${route}?${params.toString()}`;
    const requestKey = `${route}?${params.toString()}`;
    let result;

    if (lookupRequests.has(requestKey)) {
      result = await lookupRequests.get(requestKey);
    } else {
      const request = axiosInstance.get(url).finally(() => {
        lookupRequests.delete(requestKey);
      });
      lookupRequests.set(requestKey, request);
      result = await request;
    }

    dispatch(
      updateField({
        prop: key,
        value: disableList
          ? result.data.data
          : newList(result.data.data, labelField),
      })
    );
    dispatch(updateField({ prop: `${key}Load`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `${key}Load`, value: false }));

    handleErrors(e);
  }
}

async function fetchListNew2(
  dispatch,
  filters,
  key,
  route,
  labelField,
  labelField2,
  disableList = false
) {
  try {
    dispatch(updateField({ prop: `${key}Load`, value: true }));

    let url = `${route}?`;

    if (filters && Object.keys(filters).length > 0) {
      url += new URLSearchParams(filters).toString() + "&";
    }

    url += "page=1&perpage=10000";

    const result = await axiosInstance.get(url);

    dispatch(
      updateField({
        prop: key,
        value: disableList
          ? result.data.data
          : newList2(result.data.data, labelField, labelField2),
      })
    );
    dispatch(updateField({ prop: `${key}Load`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `${key}Load`, value: false }));

    handleErrors(e);
  }
}

export const getPostCategories = (filters, rel) => async (dispatch) => {
  await fetchList(
    dispatch,
    filters || {},
    rel,
    "postCategories",
    "post-categories"
  );
};

export const getProductCategories = (filters, rel) => async (dispatch) => {
  await fetchList(
    dispatch,
    filters || {},
    rel,
    "productCategories",
    "product-categories"
  );
};

export const getCategories = (filters) => async (dispatch) => {
  await fetchListNew(
    dispatch,
    filters || {},
    "categories",
    "category-panel",
    "translations.fa.title"
  );
};

export const getAdmins = (filters) => async (dispatch) => {
  await fetchListNew(
    dispatch,
    filters || {},
    "admins",
    "admin-panel",
    ["translations.fa.name", "translations.fa.lastName"]
  );
};

export const getSliderName = (filters) => async (dispatch) => {
  await fetchListNew(dispatch, filters || {}, "slider", "slider-panel", "type");
};

export const getCategoriesNew = (filters) => async (dispatch) => {
  await fetchListNew2(
    dispatch,
    filters || {},
    "categories",
    "category-panel",
    "translations.fa.title",
    "type"
  );
};

export const getTags = (filters) => async (dispatch) => {
  await fetchListNew(
    dispatch,
    filters || {},
    "tags",
    "tag-panel",
    "translations.fa.title"
  );
};

export const getPermissions = (filters) => async (dispatch) => {
  await fetchListNew(
    dispatch,
    filters || {},
    "permissions",
    "/config/permissions",
    "",
    true
  );
};

export const getGenres = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "genres", "genres");
};
export const getLanguages = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "languages", "languages");
};
export const getUsers = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "users", "users");
};
export const getRoles = (filters) => async (dispatch) => {
  await fetchListNew2(
    dispatch,
    filters,
    "roles",
    "role-panel",
    "faName",
    "name"
  );
};

export const getAbilities = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "config", "abilities", true);
};

export const getActivityFields = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "activityFields", "activity-fields");
};
export const getCountries = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "countries", "countries");
};
export const getCasts = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "casts", "casts");
};
export const getSliders = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "sliders", "sliders");
};
export const getMenus = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "menus", "menus");
};

export const getParentMenuItems = (menu_id, filters, rel) => async (
  dispatch
) => {
  await fetchList(
    dispatch,
    filters,
    rel,
    "parentMenuItems",
    "parent-menu-items/" + menu_id
  );
};

export const getSeries = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "series", "series", true);
};
export const getProductOwners = (filters, rel) => async (dispatch) => {
  await fetchList(
    dispatch,
    filters,
    rel,
    "productOwners",
    "product-owners",
    true
  );
};
export const getCafes = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "cafes", "cafes", true);
};

export const getGlobalSearch = (key) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `globalSearchLoad`, value: true }));
    if (key.length > 1) {
      const result = await axiosInstance.get(`/core/search-every-where/${key}`);
      dispatch(updateField({ prop: `globalSearch`, value: result.data }));
    } else {
      dispatch(
        updateField({
          prop: `globalSearch`,
          value: {
            users: [],
            products: [],
            festivals: [],
            packages: [],
          },
        })
      );
    }

    dispatch(updateField({ prop: `globalSearchLoad`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `globalSearchLoad`, value: false }));
    handleErrors(e);
  }
};

export const getCrmSearch = (key) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));
    dispatch(updateField({ prop: `crmUser`, value: null }));
    if (key.length > 1) {
      const result = await axiosInstance.get(`/crm?key=${key}`);
      dispatch(updateField({ prop: `crmSearch`, value: result.data }));
    } else {
      dispatch(updateField({ prop: `crmSearch`, value: [] }));
    }

    dispatch(updateField({ prop: `crmLoad`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};

export const getCrm = (id) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));

    const result = await axiosInstance.get(`/crm/${id}`);
    dispatch(updateField({ prop: `crmUser`, value: result.data }));

    dispatch(updateField({ prop: `crmLoad`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    dispatch(updateField({ prop: `crmUser`, value: null }));
    handleErrors(e);
  }
};

export const getFestival = (id) => async (dispatch) => {
  try {
    const result = await axiosInstance.get(`/festivals/${id}`);
    return result.data;
  } catch (e) {
    handleErrors(e);
  }
};
export const getProductViewCount = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.get(`/products/${id}/view-report`);
    cb(result.data);
    return result.data;
  } catch (e) {
    handleErrors(e);
  }
};

export const manageFestivalWidgets = (id, values) => async (dispatch) => {
  try {
    const result = await axiosInstance.put(
      `/festivals/${id}/manage-widgets`,
      values
    );
    return result.data;
  } catch (e) {
    handleErrors(e);
  }
};

export const storeDirectorProfile = (id, values, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.post(
      `/directors/${id}/store-director-profile`,
      values
    );
    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const chargeWallet = (id, values, cb) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));

    const result = await axiosInstance.post(`/crm/${id}/charge-wallet`, values);
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};
export const withdrawWallet = (id, values, cb) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));

    const result = await axiosInstance.post(
      `/crm/${id}/withdraw-wallet`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};

export const useCafeTicket = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.post(`/me/use-cafe-ticket/${id}`);

    cb();
  } catch (e) {
    handleErrors(e);
  }
};

export const createLiveStream = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.put(`/lives/${id}/create-stream`);

    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const deleteLiveStream = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.put(`/lives/${id}/delete-stream`);

    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const getDirectorDashboard = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/crm/${user_id}/get-director-dashboard-data`;

    if (from) {
      url = `/crm/${user_id}/get-director-dashboard-data?from=${from}`;
    }
    if (to) {
      url = `/crm/${user_id}/get-director-dashboard-data?to=${to}`;
    }
    if (to && from) {
      url = `/crm/${user_id}/get-director-dashboard-data?from=${from}&to=${to}`;
    }
    const result = await axiosInstance.get(url);

    cb(result.data);
  } catch (e) {
    handleErrors(e);
  }
};
export const getCrmUserViews = (user_id, cb) => async (dispatch) => {
  try {
    let url = `/crm/${user_id}/views`;

    const result = await axiosInstance.get(url);

    cb(result.data);
  } catch (e) {
    handleErrors(e);
  }
};

export const getDirectorReportScreening = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/crm/${user_id}/get-director-screening-report`;

    if (from) {
      url = `/crm/${user_id}/get-director-screening-report?from=${from}`;
    }
    if (to) {
      url = `/crm/${user_id}/get-director-screening-report?to=${to}`;
    }
    if (to && from) {
      url = `/crm/${user_id}/get-director-screening-report?from=${from}&to=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_director" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};
export const getDirectorYearlyReport = (
  user_id,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/directors/${user_id}/report`;

    if (from) {
      url = `/directors/${user_id}/report?from_year=${from}`;
    }
    if (to) {
      url = `/directors/${user_id}/report?to_year=${to}`;
    }
    if (to && from) {
      url = `/directors/${user_id}/report?from_year=${from}&to_year=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "director_yearly_report" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const getDirectorReportMovies = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/crm/${user_id}/get-director-movies-report`;

    if (from) {
      url = `/crm/${user_id}/get-director-movies-report?from=${from}`;
    }
    if (to) {
      url = `/crm/${user_id}/get-director-movies-report?to=${to}`;
    }
    if (to && from) {
      url = `/crm/${user_id}/get-director-movies-report?from=${from}&to=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_director" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const getDirectorReportSingle = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/crm/${user_id}/get-director-single-report`;

    if (from) {
      url = `/crm/${user_id}/get-director-single-report?from=${from}`;
    }
    if (to) {
      url = `/crm/${user_id}/get-director-single-report?to=${to}`;
    }
    if (to && from) {
      url = `/crm/${user_id}/get-director-single-report?from=${from}&to=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_director" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const downloadFestivalReport = (festival_id) => async (dispatch) => {
  try {
    let url = `/festivals/${festival_id}/get-festival-report`;

    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "festival_report" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};
export const editSubscription = (u_id, s_id, values, cb) => async (
  dispatch
) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));
    const result = await axiosInstance.post(
      `/crm/${u_id}/edit-subscription/${s_id}`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};
export const addSubscription = (u_id, values, cb) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));
    const result = await axiosInstance.post(
      `/crm/${u_id}/add-subscription`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};

export const getSeasons = (id, filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "seasons", `serie-seasons/${id}`);
};

export const getFestivals = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "festivals", "festivals");
};

export const getProducts = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "products", "products", true);
};

export const getPackages = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "packages", "packages");
};
